import { RemoveSymbolsByMaskActionHandler, type ReplayPlugin } from "@slot/client-engine";
import { buildReelsReplayPlugin } from "./buildReelsReplayPlugin";
import type { PresentationTaskRunner } from "@slot/presentation";
import type { BaseGridPresenter, GridPresenter, MechanicPlugin } from "@slot/mechanics-core";

/**
 * Tumbling reels as a mechanic plugin — the OPT-IN tumble variant of `buildReelsReplayPlugin`. The
 * frame presenter is the plain-reels one (a `TumbleReelGridPresenter` routes collapse events to the
 * tumble drop); the removal handler shrinks the winning cells through the composite, then holds a
 * beat on engine time (speed-scaled, pause-aware) before the collapse event drives the drop.
 */
export function buildTumbleReelsReplayPlugin(input: {
  gridPresenter: GridPresenter;
  /** The tumble adapter (`TumbleReelGridPresenter`), typed by the layer interface it fulfils. */
  basePresenter: BaseGridPresenter;
  /** Drives the post-removal hold on engine time. */
  runner: PresentationTaskRunner;
  /** Beat of stillness after the shrink completes, before the collapse drop. 0 = none. */
  postRemovalHoldSeconds: number;
}): MechanicPlugin {
  const base = buildReelsReplayPlugin({ gridPresenter: input.gridPresenter, basePresenter: input.basePresenter });
  const plugin: ReplayPlugin = {
    name: "tumble-reels",
    actionHandlers: [
      new RemoveSymbolsByMaskActionHandler(async (positionMask) => {
        await input.gridPresenter.removeSymbolsByMask(positionMask);
        if (input.postRemovalHoldSeconds > 0) {
          await input.runner.sleep(input.postRemovalHoldSeconds);
        }
      }),
    ],
  };
  return { framePresenter: base.framePresenter, plugin, slamScopes: base.slamScopes };
}
